import React, { useContext, useEffect, useRef, useState } from 'react';
import './sitesExpandable.css';
import { RackExpandable } from '../RackExpandable/RackExpandable';
import { FormControl, RadioGroup, Radio, FormControlLabel, Tooltip, Checkbox, Popover } from '@mui/material';
import MultioptionButton from '../../../../components/Buttons/MultioptionButton';
import { localStorageGet, localStorageRemove, localStorageSave } from '../../../../services/localStorageService';
import { HTTP_RESPONSE_CODES, LABELS } from '../../../../globals/globals';
import { createRack, deleteSite, getRacks, getSite, saveAircraftCompatibility, updateSite } from '../../services/locationsConfigurationService';
import { useSnackBar } from "../../../../hooks/useSnackBar";
import { DialogContext } from "../../../../contexts/DialogContext";
import { DeleteSiteModal } from './deleteSiteModal/DeleteSiteModal';
import { getUserCompanyId } from '../../../../services/authService';
import { environment } from '../../../../environments/environment';
import { dropdownConfig } from '../../../../services/dropdownsConfigService';
import { Dropdowns } from '../../../../components/Dropdowns/Dropdowns';
import { AircraftTypeItem } from './AircraftTypeItem/AircraftTypeItem';
import { PhoneInput } from 'react-international-phone';
import Input from '../../../../components/Inputs/Input';
import { LocationsContext } from '../../contexts/LocationsContext';

const typeSitesMapping = {
    1: "Hangar",
    2: "Warehouse",
    // 3: "Bonded Warehouse",
    4: "Line Maintenance",
    5: "Shop",
    6: "Vendor Managed"
};

export const SitesExpandable = ({ siteBasicInfo, isDraft, isNewSite = false, reload = "", location_id, informationOfDraft, listLenght }) => {
    const [version, setVersion] = useState(0);
    const [shippingAddressVersion, setShippingAdressVersion] = useState(null);
    const [shippingAddressId, setShippingAdressId] = useState(null);
    const siteDraftPrefix = "configuration/locationConfiguration/draft/sites/";
    const rackDraftPrefix = "configuration/locationConfiguration/draft/racks/";
    const shelfDraftPrefix = "configuration/locationConfiguration/draft/shelves/";
    const binDraftPrefix = "configuration/locationConfiguration/draft/bins/";

    const [UOMdropdownFilters, setUOMDropdownFilters] = useState([])

    // const [isOpen, setIsOpen] = useState(false);
    // const [openEditionMode, setOpenEditionMode] = useState(false);
    const [viewMode, setViewMode] = useState('closed'); // 'closed' | 'form' | 'racks' | 'edit'
    const [isExpanded, setIsExpanded] = useState(false);
    const [data, setData] = useState(siteBasicInfo);
    const [typeLocationSelected, setTypeLocationSelected] = useState(1);
    const [siteNameValue, setSiteNameValue] = useState("");
    const [siteCodeValue, setSiteCodeValue] = useState("");

    const [draft, setDraft] = useState(isDraft);
    const [childrenDraft, setChildrenDraft] = useState(false)
    const [newSite, setNewSite] = useState(isNewSite);
    const [siteCompleteData, setSiteCompleteData] = useState(null);
    const [siteDataInDraft, setSiteDataInDraft] = useState(null);
    const { warningMsg, successMsg, errorMsg, infoMsg } = useSnackBar();
    const [hasNameError, setHasNameError] = useState(false);
    const [hasCodeError, setHasCodeError] = useState(false);

    const [hasTypeError, setHasTypeError] = useState(false);
    const [totalRacks, setTotalRacks] = useState(null);

    // const typeName = typeSitesMapping[typeLocationSelected] || "";
    const { openDialog, closeDialog } = useContext(DialogContext);
    const [racks, setRacks] = useState([])
    const [racksInDraft, setRacksInDraft] = useState([])
    const [allRacks, setAllRacks] = useState([])
    const [mostRecentRack, setMostRecentRack] = useState(null)
    const [page, setPage] = useState(0)
    const [pageSize, setPageSize] = useState(environment.ElemensPerPage)


    const [UOMDropdown, setUOMDropdown] = useState(null)
    const [countryDropdown, setCountryDropdown] = useState(null)
    const [stateDropdown, setStateDropdown] = useState(null)
    const [cityDropdown, setCityDropdown] = useState(null)
    const [aircraftDropdown, setAircraftDropdown] = useState(null)
    const [UOMSelected, setUOMSelected] = useState(null)

    const [street1, setStreet1] = useState("")
    const [street2, setStreet2] = useState("")
    const [countrySelected, setCountrySelected] = useState(null)
    const [stateSelected, setStateSelected] = useState(null)
    const [citySelected, setCitySelected] = useState(null)
    const [postalCode, setPostalCode] = useState("")
    const [phone, setPhone] = useState("")
    const [email, setEmail] = useState("")

    const [avaiableArea, setAvailableArea] = useState(null)
    const [overridedAddress, setOverridedAddress] = useState(false)
    const [bondedWarehouse, setBondedWharehouse] = useState(false)

    const [availableForAircraft, setAvailableForAircraft] = useState(false)

    const [hasStreet1Error, setHasStreet1Error] = useState(false);
    const [hasPostalCodeError, setHasPostalCodeError] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [aircraftTypesList, setAircraftTypesList] = useState([]);

    const [aircraftTypesSelected, setAircraftTypesSelected] = useState(null);
    const [estimatedCapacity, setEstimatedCapacity] = useState();
    const [preselectUOMDrop, setPreselectUOMDrop] = useState(null)
    const [hasUOMError, setHasUOMError] = useState(false)
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredList, setFilteredList] = useState(aircraftTypesList);

    const [preSelectCountry, setPreselectCountry] = useState(null);
    const [preSelectState, setPreselectState] = useState(null);
    const [preSelectCity, setPreselectCity] = useState(null);

    const [hasCountryError, setHasCountryError] = useState(false);
    const [hasStateError, setHasStateError] = useState(false);
    const [hasCityError, setHasCityError] = useState(false);
    const [hasEmailError, setHasEmailError] = useState(false)
    const [hasAvailableAreaError, setHasAvailableAreaError] = useState(false)
    const { draftStatusChanged, setDraftStatusChanged } = useContext(LocationsContext);


    const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchTerm(value);
    };


    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredList(aircraftTypesList);
        } else {
            setFilteredList(
                aircraftTypesList.filter(aircraft =>
                    aircraft.aircraftType.toLowerCase().includes(searchTerm)
                )
            );
        }
    }, [searchTerm, aircraftTypesList]);

    const validateFields = () => {
        let isValid = true;

        if (!siteNameValue.trim()) {
            setHasNameError(true);
            isValid = false;
        } else {
            setHasNameError(false);
        }

        if (!siteCodeValue.trim()) {
            setHasCodeError(true);
            isValid = false;
        } else {
            setHasCodeError(false);
        }

        if (!typeLocationSelected) {
            setHasTypeError(true);
            isValid = false;
        } else {
            setHasTypeError(false);
        }

        if (typeLocationSelected == 1) {

            if (UOMSelected == null || UOMSelected == undefined || UOMSelected == "") {
                setHasUOMError(true);
                isValid = false
            } else {
                setHasUOMError(false);

            }
            if (avaiableArea == null || avaiableArea == undefined || avaiableArea == "" || avaiableArea <= 0) {
                setHasAvailableAreaError(true);
                isValid = false
            } else {
                setHasAvailableAreaError(false);

            }
            if (overridedAddress) {
                if (!street1.trim()) {
                    setHasStreet1Error(true)
                    isValid = false
                } else {
                    setHasStreet1Error(false)
                }
                if (countrySelected == null || countrySelected == undefined || countrySelected == "") {
                    setHasCountryError(true)
                    isValid = false
                } else {
                    setHasCountryError(false)
                }
                if (stateSelected == null || stateSelected == undefined || stateSelected == "") {
                    setHasStateError(true)
                    isValid = false
                } else {
                    setHasStateError(false)
                }
                if (citySelected == null || citySelected == undefined || citySelected == "") {
                    setHasCityError(true)
                    isValid = false
                } else {
                    setHasCityError(false)
                }
                if (postalCode == null || postalCode == undefined || postalCode == "") {
                    setHasPostalCodeError(true)
                    isValid = false
                } else {
                    setHasPostalCodeError(false)
                }

                if (email !== undefined && email !== null && email !== "") {
                    if (!environment.emailRegexPattern.test(email)) {
                        warningMsg("Please enter a valid email.", "The Type Of Email Is Not A valid Email.");
                        setHasEmailError(true)
                        isValid = false
                        return
                    } else {
                        setHasEmailError(false)

                    }
                }
            }
        } else if (typeLocationSelected == 2) {
            if (overridedAddress) {
                if (!street1.trim()) {
                    setHasStreet1Error(true)
                    isValid = false
                } else {
                    setHasStreet1Error(false)
                }
                if (countrySelected == null || countrySelected == undefined || countrySelected == "") {
                    setHasCountryError(true)
                    isValid = false
                } else {
                    setHasCountryError(false)
                }
                if (stateSelected == null || stateSelected == undefined || stateSelected == "") {
                    setHasStateError(true)
                    isValid = false
                } else {
                    setHasStateError(false)
                }
                if (citySelected == null || citySelected == undefined || citySelected == "") {
                    setHasCityError(true)
                    isValid = false
                } else {
                    setHasCityError(false)
                }
                if (postalCode == null || postalCode == undefined || postalCode == "") {
                    setHasPostalCodeError(true)
                    isValid = false
                } else {
                    setHasPostalCodeError(false)
                }
            }
        }

        if (!isValid) {
            warningMsg("Fields requerid", "Certain empty fields or negative numbers are not allowed");
        }

        return isValid;
    };

    const getSiteInformation = async () => {
        const request = await getSite(siteBasicInfo.id);
        if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            setSiteCompleteData(request.data.load);
        }
    };

    const saveSite = async (typeOfFinish = "") => {
        if (!validateFields()) {
            return
        }

        const request = await updateSite(siteDataInDraft);
        if (request.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
            if (typeOfFinish === "end") {
                successMsg("Site Saved", "Site Has Been saved Successfully.")
                localStorageRemove(siteDraftPrefix, { siteId: data.id.toString() });
                setDraftStatusChanged(!draftStatusChanged)

                setDraft(false);
                setNewSite(false);
                setIsExpanded(false);
                setViewMode("closed");
                setSiteDataInDraft(null)
                setSiteCompleteData(request.data.load)
                reload(siteBasicInfo.id)


            } else {
                successMsg("Site Saved", "Site Has Been saved Successfully.")
                setNewSite(false);
                // setSiteCompleteData(request.data.load);
                setVersion(request.data.load.version)
                setShippingAdressId(request.data.load.shippingAddress.id)
                setShippingAdressVersion(request.data.load.shippingAddress.version)
                const updatedData = {
                    version: request.data.load.version,
                    id: request.data.load.id,
                    name: request.data.load.name,
                    siteTypeId: request.data.load.siteTypeId.toString(),
                    active: true,
                    capacity: request.data.load.capacity,
                    unitsOfMeasureId: request.data.load.unitsOfMeasureId,
                    aircraftCompatibility: request.data.load.aircraftCompabilities,
                    bondedWarehouse: request.data.load.bondedWarehouse,
                    locationId: location_id,
                };
                setSiteDataInDraft(updatedData);
            }
        }

    };

    const deleteThisSite = async () => {
        let siteId = siteBasicInfo.id;
        const request = await deleteSite(siteId);

        if (request.data.responseCode == HTTP_RESPONSE_CODES.DELETED) {
            successMsg("Site Deleted", "Site Deleted Successfully")
            localStorageRemove(siteDraftPrefix, { siteId: data.id.toString() });
            setDraftStatusChanged(!draftStatusChanged)

            closeDialog();
            if (reload) {
                reload(siteBasicInfo.id);
            }
        }
    };

    const cancelSiteEdition = () => {
        setSiteNameValue(data.name || "");
        setSiteCodeValue(data.code || "");

        setTypeLocationSelected(data.siteTypeId || "");
        localStorageRemove(siteDraftPrefix, { siteId: siteBasicInfo.id });
        setDraftStatusChanged(!draftStatusChanged)

        setIsExpanded(false);
        setViewMode("closed");
        setDraft(false);
        successMsg("Discarded", "Changes Discarded Successfully.")
        setTimeout(() => {
            if (reload) {
                reload()
            }
        }, environment.debounceTime)
    };

    const openDeleteDialog = () => {
        openDialog({
            component: DeleteSiteModal,
            props: {
                onClose: closeDialog,
                siteName: siteBasicInfo.name,
                siteType: siteBasicInfo.type,
                deleteSite: deleteThisSite
            }
        });
    };

    const multiOptionsBtn = [
        { label: 'Save', icon: "icon-save", id: 'save' },
        { label: 'Save and Continue Editing', icon: "icon-save", id: 'save-continue' },
        { label: 'Cancel', icon: "icon-cross", id: 'cancel', type: 'danger' }
    ];

    const buttonsCallback = {
        "save": () => saveSite("end"),
        "save-continue": () => saveSite("continue"),
        "cancel": () => cancelSiteEdition(),
    };


    const getAllRacks = async () => {
        let body = [
            {
                columnName: "siteId",
                value: siteBasicInfo.id,
            },
            {
                columnName: "accountId",
                value: [parseInt(localStorage.getItem("u_account_id"))],
            },
        ]
        let racksInDraft = localStorageGet(rackDraftPrefix, { siteId: siteBasicInfo.id })
        const request = await getRacks(page, pageSize, body)

        if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
            setRacksInDraft(racksInDraft)
            setRacks(() => {
                return request.data.load
            })
            setTotalRacks(request.data.totalRecords)
            if (request.data.load.length <= 0 && racksInDraft.length <= 0) {
                setIsExpanded(false);
                setViewMode("closed");
            } else {
                setIsExpanded(true)
            }
        }
    }

    const createNewRack = async () => {
        const request = await createRack();
        if (request.data.responseCode == HTTP_RESPONSE_CODES.CREATED) {
            localStorageSave(rackDraftPrefix, { locationId: location_id, siteId: siteBasicInfo.id, rackId: request.data.load.id }, request.data.load)
            setDraftStatusChanged(!draftStatusChanged)
            setMostRecentRack(request.data.load.id)
            successMsg("Rack Created", "Rack Created successfully")
            getAllRacks()
            setViewMode("racks")
        }
    }

    const combineRacks = () => {
        const uniqueDraftRacks = racksInDraft?.length > 0
            ? racksInDraft.filter(r =>
                !racks.some(rack => rack.id === r.id)
            )
            : [];

        setAllRacks([...uniqueDraftRacks, ...racks]);
    };

    const reloadRack = () => {
        getAllRacks()
    }

    const createAircraft = async () => {
        if (aircraftTypesSelected !== null && estimatedCapacity >= 0 && estimatedCapacity !== undefined && estimatedCapacity !== null) {
            const newAircraft = {
                version: 0,
                id: 0,
                siteId: siteBasicInfo.id,
                aircraftTypeId: aircraftTypesSelected["act.id"],
                aircraftType: aircraftTypesSelected.type_name,
                estimatedCapacity: parseInt(estimatedCapacity)
            }

            let request = await saveAircraftCompatibility(newAircraft)

            if (request.data.responseCode == HTTP_RESPONSE_CODES.UPDATED) {
                successMsg("Aircraft Type Created", "Aircraft Type Created Successfully , you can continue editing.")
                // getSiteInformation()
                setEstimatedCapacity(null)
                setAircraftTypesSelected(null)
                setAircraftTypesList((prevValues) => {
                    return [...prevValues, request.data.load]
                })
                closePopOver()
            }
        } else {
            warningMsg("Fields Required", "Select an aircraft type and capacity to continue.")
        }
    }

    // dropdowns

    const getDropdownConfigUOM = async () => {
        let id = 40;
        const request = await dropdownConfig(id);
        if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            setUOMDropdown(request.data.load);
        }
    }

    const getDropdownConfigCountry = async () => {
        let id = 25;
        const request = await dropdownConfig(id);
        if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            setCountryDropdown(request.data.load);
        }
    }

    const getDropdownConfigState = async () => {
        let id = 26;
        const request = await dropdownConfig(id);
        if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            setStateDropdown(request.data.load);
        }
    }

    const getDropdownConfigCity = async () => {
        let id = 28;
        const request = await dropdownConfig(id);
        if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            setCityDropdown(request.data.load);
        }
    }
    const getDropdownConfigAircraftType = async () => {
        let id = 30;
        const request = await dropdownConfig(id);
        if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            setAircraftDropdown(request.data.load);
        }
    }
    const getAllDropdowns = async () => {
        const results = await Promise.all([
            getDropdownConfigUOM(),
            getDropdownConfigCountry(),
            getDropdownConfigState(),
            getDropdownConfigCity(),
            getDropdownConfigAircraftType()
        ])

        return results
    }

    const getCountrySelected = (data) => {
        setCountrySelected(data)
        setPreselectCountry(data.id)
        setPreselectState(null)
        // setStateSelected(null)
        setPreselectCity(null)
        // setCitySelected(null)
    }

    const getStateSelected = (data) => {
        setStateSelected(data)
        setPreselectState(data.id)
        setPreselectCity(null)
        setCitySelected(null)
    }

    const getCitySelected = (data) => {
        setCitySelected(data)
        setPreselectCity(data.id)
    }
    // effects

    useEffect(() => combineRacks(), [racks, racksInDraft])

    useEffect(() => {
        if (isExpanded) {
            getSiteInformation();
        }
        if (isExpanded && viewMode == "racks") {
            getAllRacks()
        }
    }, [isExpanded]);

    useEffect(() => {
        if (siteCompleteData !== null && isExpanded) {
            const updatedData = {
                version: version,
                id: siteCompleteData.id,
                name: siteNameValue,
                code: siteCodeValue,
                siteTypeId: typeLocationSelected,
                active: true,
                capacity: avaiableArea,
                unitsOfMeasureId: UOMSelected ? UOMSelected["UOM.id"] : null,
                bondedWarehouse: bondedWarehouse,
                availableForAircraft: availableForAircraft,
                overrideShippingAddress: overridedAddress,
                locationId: location_id,
                accountId: parseInt(localStorage.getItem("u_account_id")),
                status: "active",
                shippingAddress: overridedAddress ? {
                    version: shippingAddressVersion,
                    id: shippingAddressId,
                    street1: overridedAddress ? street1 : "",
                    street2: overridedAddress ? street2 : "",
                    countryId: overridedAddress ? countrySelected?.id : "",
                    stateId: overridedAddress ? stateSelected?.id : "",
                    cityId: overridedAddress ? citySelected?.id : "",
                    postalCode: overridedAddress ? postalCode : "",
                    email: overridedAddress ? email : "",
                    phoneNumber: overridedAddress ? phone : ""
                } : null,
                aircraftCompabilities: aircraftTypesList
            };
            setSiteDataInDraft(updatedData);
        }
    }, [
        // siteCompleteData,
        siteNameValue,
        siteCodeValue,
        typeLocationSelected,
        UOMSelected,
        avaiableArea,
        availableForAircraft,
        aircraftTypesList,
        overridedAddress,
        street1,
        street2,
        countrySelected,
        stateSelected,
        citySelected,
        postalCode,
        email,
        phone,
        version,
        shippingAddressId,
        shippingAddressVersion,
        bondedWarehouse
    ]);

    useEffect(() => {
        if (informationOfDraft) {
            setSiteNameValue(informationOfDraft.name || "");
            setSiteCodeValue(informationOfDraft.code || "")
            setTypeLocationSelected(informationOfDraft.siteTypeId || "");
            setAvailableArea(informationOfDraft.capacity || "")
            setAvailableForAircraft(informationOfDraft.availableForAircraft || "")

            setOverridedAddress(informationOfDraft?.shippingAddress || "")
            setBondedWharehouse(informationOfDraft?.bondedWarehouse || "")
            setStreet1(informationOfDraft?.shippingAddress !== null ? informationOfDraft?.shippingAddress?.street1 : "")
            setStreet2(informationOfDraft?.shippingAddress !== null ? informationOfDraft?.shippingAddress?.street2 : "")

            setUOMSelected(informationOfDraft?.unitsOfMeasureId ? {
                "UOM.id": informationOfDraft?.unitsOfMeasureId
            } : "")
            setPreselectUOMDrop(informationOfDraft?.unitsOfMeasureId || "")
            setPreselectCountry(informationOfDraft?.shippingAddress !== null ? informationOfDraft?.shippingAddress?.countryId : "")
            setPreselectState(informationOfDraft?.shippingAddress !== null ? informationOfDraft?.shippingAddress?.stateId : "")
            setPreselectCity(informationOfDraft?.shippingAddress !== null ? informationOfDraft?.shippingAddress?.cityId : "")
            setCountrySelected(informationOfDraft?.shippingAddress !== null ? { "id": informationOfDraft?.shippingAddress?.countryId } : "")
            setStateSelected(informationOfDraft?.shippingAddress !== null ?
                { "id": informationOfDraft?.shippingAddress?.stateId }
                : "")
            setCitySelected(informationOfDraft?.shippingAddress !== null ?
                { "id": informationOfDraft?.shippingAddress?.cityId }
                : "")

            setPostalCode(informationOfDraft?.shippingAddress !== null ? informationOfDraft?.shippingAddress?.postalCode : "")
            setPhone(informationOfDraft?.shippingAddress !== null ? informationOfDraft?.shippingAddress?.phoneNumber : "")
            setEmail(informationOfDraft?.shippingAddress !== null ? informationOfDraft?.shippingAddress?.email : "")
            setShippingAdressId(informationOfDraft?.shippingAddress !== null ? informationOfDraft?.shippingAddress?.id : null)
            setShippingAdressVersion(informationOfDraft?.shippingAddress !== null ? informationOfDraft?.shippingAddress?.version : 0);
            setVersion(informationOfDraft.version || 0);

        } else {
            setSiteNameValue(siteCompleteData?.name || data?.name || "");
            setSiteCodeValue(siteCompleteData?.code || data?.code || "")

            setTypeLocationSelected(siteCompleteData?.siteTypeId || data?.siteTypeId || "");
            setAircraftTypesList(siteCompleteData?.aircraftCompabilities || []);
            setAvailableForAircraft(siteCompleteData?.availableForAircraft || false);
            setAvailableArea(siteCompleteData?.capacity || "");
            setUOMSelected(siteCompleteData?.unitsOfMeasureId ? {
                "UOM.id": siteCompleteData?.unitsOfMeasureId
            } : "")
            setPreselectUOMDrop(siteCompleteData?.unitsOfMeasureId || "")

            setOverridedAddress(siteCompleteData?.overrideShippingAddress || false);
            setBondedWharehouse(siteCompleteData?.bondedWarehouse || "")
            setPreselectCountry(siteCompleteData?.shippingAddress !== null ? siteCompleteData?.shippingAddress?.countryId : "")
            setPreselectState(siteCompleteData?.shippingAddress !== null ? siteCompleteData?.shippingAddress?.stateId : "")
            setPreselectCity(siteCompleteData?.shippingAddress !== null ? siteCompleteData?.shippingAddress?.cityId : "")
            setCountrySelected(siteCompleteData?.shippingAddress !== null ? { "id": siteCompleteData?.shippingAddress?.countryId } : "")
            setStateSelected(siteCompleteData?.shippingAddress !== null ? { "id": siteCompleteData?.shippingAddress?.stateId } : "")
            setCitySelected(siteCompleteData?.shippingAddress !== null ? { "id": siteCompleteData?.shippingAddress?.cityId } : "")

            setPostalCode(siteCompleteData?.shippingAddress !== null ? siteCompleteData?.shippingAddress?.postalCode : "")
            setPhone(siteCompleteData?.shippingAddress !== null ? siteCompleteData?.shippingAddress?.phoneNumber : "")
            setEmail(siteCompleteData?.shippingAddress !== null ? siteCompleteData?.shippingAddress?.email : "")
            setStreet1(siteCompleteData?.shippingAddress !== null ? siteCompleteData?.shippingAddress?.street1 : "")
            setStreet2(siteCompleteData?.shippingAddress !== null ? siteCompleteData?.shippingAddress?.street2 : "")
            setShippingAdressId(siteCompleteData?.shippingAddress !== null ? siteCompleteData?.shippingAddress?.id : null)
            setShippingAdressVersion(siteCompleteData?.shippingAddress !== null ? siteCompleteData?.shippingAddress?.version : 0);
            setVersion(siteCompleteData?.version || data?.version || 0);

        }
    }, [informationOfDraft, siteCompleteData]);


    useEffect(() => {
        if (siteDataInDraft !== null && isExpanded && viewMode == "edit") {
            localStorageSave(siteDraftPrefix, { locationId: location_id, siteId: siteBasicInfo.id.toString() }, siteDataInDraft);
            setDraftStatusChanged(!draftStatusChanged)
        }
    }, [siteDataInDraft, viewMode]);

    const validateChildDraftStatus = () => {
        let hasRacksDrafts = localStorageGet(rackDraftPrefix, { siteId: siteBasicInfo.id });
        let hasShelvesDrafts = localStorageGet(shelfDraftPrefix, { siteId: siteBasicInfo.id });
        let hasBinsDraft = localStorageGet(binDraftPrefix, { siteId: siteBasicInfo.id });

        const hasAnyChildrenDraft = (
            (hasRacksDrafts?.length || 0) > 0 ||
            (hasShelvesDrafts?.length || 0) > 0 ||
            (hasBinsDraft?.length || 0) > 0
        );

        setChildrenDraft(hasAnyChildrenDraft);
    };



    useEffect(() => {
        validateChildDraftStatus()
    }, [draftStatusChanged])

    useEffect(() => {
        validateChildDraftStatus()
        if (newSite) {
            setViewMode("edit");
            setIsExpanded(true);
        }
        setMostRecentRack(null)
        setTotalRacks(siteBasicInfo.racks);

    }, []);


    useEffect(() => {
        if (typeLocationSelected == 1) {
            getAllDropdowns()
        }
    }, [typeLocationSelected])

    useEffect(() => {
        setUOMDropdownFilters(() => {
            return [
                { columnName: "l.id", "value": location_id },
                { columnName: "measure_type", "value": "area" },
                { columnName: "context", "value": "site" }
            ]
        })
    }, [location_id])

    useEffect(() => {
        if (siteCompleteData !== null) {
            setAircraftTypesList(siteCompleteData.aircraftCompabilities)
        }
    }, [siteCompleteData])

    const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
        let setDropdown;

        switch (dropdownId) {
            case 25:
                setDropdown = setCountryDropdown;
                break;
            case 26:
                setDropdown = setStateDropdown;
                break;
            case 28:
                setDropdown = setCityDropdown;
                break;
            default:
                return;
        }

        const debounceUpdate = setTimeout(() => {
            setDropdown((prevState) => ({
                ...prevState,
                parentValues,
                dependenciesToUpdate,
                reload: true,
            }));
        }, 200);

        return () => clearTimeout(debounceUpdate);
    };

    const resetDropdownsReload = () => {
        setCountryDropdown((prevState) => ({ ...prevState, reload: false }));
        setStateDropdown((prevState) => ({ ...prevState, reload: false }));
        setCityDropdown((prevState) => ({ ...prevState, reload: false }));
    };

    const openPopOver = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const closePopOver = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);

    const getAircraftTypeSelection = (data) => {
        setAircraftTypesSelected(data)
    }

    const getUOMSelected = (data) => {
        setUOMSelected(data)
    }

    const updateAircraftTypeItem = (updatedItem) => {
        setAircraftTypesList(prevList =>
            prevList.map(item =>
                item.id === updatedItem.id ? updatedItem : item
            )
        );
    };

    const handleHeaderClick = () => {
        if (viewMode === 'edit') {
            return
        };

        // if (viewMode == "closed" && siteCompleteData == null || siteCompleteData == undefined) {
        //     infoMsg("Information", "This is an unsaved site, please click the edit icon.")
        //     setIsExpanded(false);
        //     setViewMode("closed")
        // }
        if (viewMode !== 'closed') {
            // Si está mostrando algo (form o racks), cerrarlo
            setViewMode('closed');
            setIsExpanded(false);
        } else {
            // Si está cerrado, abrir el formulario
            setViewMode('form');
            setIsExpanded(true);
        }
    };

    const handleViewRacks = (e) => {
        e.stopPropagation();

        if (viewMode === 'racks') {
            setViewMode('closed');
            setIsExpanded(false);
        } else {

            setViewMode('racks');
            setIsExpanded(true);
        }
    };

    const handleEditClick = (e) => {
        e.stopPropagation();
        setViewMode('edit');
        setIsExpanded(true);
        setDraft(true);
    };

    return (
        <>
            <Popover
                anchorEl={anchorEl}
                open={open}
                onClose={closePopOver}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}>
                <div className="popOver-content-site">
                    <h3 className='ellipsis'>+ Add Estimated Aircraft Capacity</h3>
                    <div className="dropdown-aircraftType-cont">
                        {
                            aircraftDropdown && <Dropdowns onOptionSelect={getAircraftTypeSelection} data={aircraftDropdown} />
                        }
                    </div>
                    <section>
                        <p>Estimated Aircraft Capacity</p>
                        <Input isNumeric={true} value={estimatedCapacity} onChange={(e) => {
                            setEstimatedCapacity(e.target.value)
                        }} label={"Estimated Capacity"} upperCase={true} />
                    </section>
                    <div className="estimated-aircraft-cap-btn-cont">
                        <button onClick={createAircraft}>
                            <i className='icon-add-new'></i>
                            Add
                        </button>
                        <button onClick={closePopOver}>
                            <i className='icon-cross'></i>
                            Cancel
                        </button>
                    </div>
                </div>
            </Popover>
            <section className='sites-grey-bg' style={{
                background: viewMode == "edit" || viewMode || "form" ? "var(--white-100)" : "",
                border: viewMode == "edit" || viewMode == "form" ? "1px solid #AFAFAF" : ""
            }}>
                <section className="sites-expandable-header"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            handleHeaderClick()
                        }
                    }}
                    onClick={handleHeaderClick}
                    style={{
                        backgroundColor: viewMode === 'form' ? 'transparent' : viewMode === 'racks' ? '#EFFCFF' : 'transparent',
                        border: viewMode === 'form' ? 'none' : viewMode === 'racks' ? '1px solid #B9D8DF' : viewMode == "closed" ? "1px solid #E6E6E6" : 'none',
                    }}
                >

                    {(newSite || draft || childrenDraft) && <span className='draft-site-span'>{LABELS.DRAFT}</span>}
                    {isExpanded && viewMode !== "edit" ? <span></span> : null}
                    <h4>Site</h4>
                    <p className='ellipsis' style={{
                        width: "23%",
                        minWidth: "5rem"
                    }}>
                        <span>{siteNameValue || ""}</span>
                    </p>
                    <p className='ellipsis' style={{
                        width: "15%",
                        minWidth: "5rem"
                    }}>
                        <span>{siteCodeValue || ""}</span>
                    </p>
                    <p style={{
                        width: "16.65%",
                        minWidth: "3rem"
                    }}>
                        <span>{typeLocationSelected ? typeSitesMapping[typeLocationSelected] : typeSitesMapping[data.type]}</span>
                    </p>
                    <p style={{
                          width: "15%",
                        minWidth: "3rem"
                    }}>
                        Total Racks <Tooltip title={"View Racks"} arrow ><button className='site-racks-span' onClick={handleViewRacks}>{totalRacks || 0}</button></Tooltip>
                    </p>
                    <div className="actions-section-sitesExp">
                        <p style={{
                            color: "var(--grey-200)"
                        }} >New Rack</p>
                        {viewMode !== "edit" && <Tooltip title="Add New Rack" arrow>
                            <button onClick={(e) => {
                                e.stopPropagation()
                                createNewRack()
                            }}>
                                <i className="icon-add-aircraft" style={{
                                    fontSize: "1rem",
                                    color: "var(--grey-200)",
                                }} />
                            </button>

                        </Tooltip>}

                        {
                            viewMode !== "edit" && <Tooltip title="View Racks" arrow>
                                <button onClick={handleViewRacks}>
                                    <i className="icon-icon_view_childs" style={{
                                        fontSize: "1rem",
                                        color: "var(--grey-200)",
                                    }} />
                                </button>
                            </Tooltip>
                        }

                        {viewMode !== 'edit' && (
                            <Tooltip title="Edit Site" arrow>
                                <button onClick={handleEditClick}>
                                    <i className="icon-edit" style={{
                                        fontSize: "1rem",
                                        color: "var(--grey-200)",
                                    }} />
                                </button>
                            </Tooltip>
                        )}


                        <Tooltip title="Delete Site" arrow>
                            <button onClick={(e) => {
                                e.stopPropagation()
                                openDeleteDialog();
                            }}>
                                <i className="icon-delete-new" style={{
                                    fontSize: "1rem",
                                    color: "var(--grey-200)",

                                }} />
                            </button>
                        </Tooltip>
                        {viewMode == "edit" && <MultioptionButton buttons={multiOptionsBtn} buttonCallbacks={buttonsCallback} />}
                    </div>
                </section>
                <section className={`sites-expandable-content ${isExpanded ? 'open' : ''}`}>
                    {viewMode == "edit" ?
                        <div className="form-edit-site-exp">
                            <section className='form-edit-site-exp-top'>
                                <div className='form-edit-inp-Cont'>
                                    <Input
                                        disableAutocomplete={true}
                                        autoFocus={newSite}
                                        error={hasNameError}
                                        label='Name'
                                        name={"Name"}
                                        value={siteNameValue}
                                        onChange={(e) => {
                                            setSiteNameValue(e.target.value);
                                            setHasNameError(false);
                                        }}
                                        upperCase={true}
                                    />

                                    <Input
                                        disableAutocomplete={true}
                                        error={hasCodeError}
                                        label='Code'
                                        name={"Code"}
                                        value={siteCodeValue}
                                        onChange={(e) => {
                                            setSiteCodeValue(e.target.value);
                                            setHasCodeError(false);
                                        }}
                                        upperCase={true}
                                        style={{
                                            width: "40%"
                                        }}
                                    />

                                </div>
                                <FormControl sx={{ flexDirection: "row", alignItems: "center", flexGrow: "1", gap: "var(--gap)", justifyContent: "space-around" }}>
                                    <p style={{ fontSize: "calc(var(--p-size) + .1rem)", fontWeight: "500", minWidth: "2rem", color: "var(--black)" ,}}>Type</p>
                                    <RadioGroup
                                        row
                                        value={typeLocationSelected || ""}
                                        onChange={(e) => setTypeLocationSelected(e.target.value)}
                                        sx={{
                                            gap: "calc(var(--gap))",

                                            flexGrow: "1",
                                        }}

                                    >
                                        {Object.entries(typeSitesMapping).map(([key, value]) => (
                                            <FormControlLabel
                                                onChange={
                                                    () => {
                                                        setHasTypeError(false)
                                                    }
                                                }
                                                key={key}
                                                value={key}
                                                control={<Radio sx={{ padding: "0", ".css-z8nmqa-MuiSvgIcon-root": { fill: "var(--green-350)" }, ".css-1bz1rr0-MuiSvgIcon-root": { fill: "var(--grey-300)" } }} />}
                                                label={<p className='site-labeL-radio-form' style={{
                                                    color: hasTypeError ? "var(--input-error)" : ""
                                                }}>{value}</p>}
                                                sx={{ background: "var(--white)", height: "var(--input-height)", marginRight: "0", marginLeft: "0", width: "auto", padding: "0.3rem .3rem .3rem .3rem", borderRadius: "var(--button-radius)", gap: "3px", border: hasTypeError ? "2px solid var(--input-error)" : "", }}
                                            />
                                        ))}
                                    </RadioGroup>
                                </FormControl>
                            </section>
                            {
                                (typeLocationSelected == 1 || typeLocationSelected == 2) && (
                                    <section className='type-Hangar-form'>
                                        <div className="hangar-capacity-cont"

                                        >
                                            <h2>
                                                {
                                                    typeLocationSelected == "1" ? "Hangar Configuration" : typeLocationSelected == "2" ? "Warehouse Configuration" : ""
                                                }

                                            </h2>
                                            <div>
                                                <section

                                                    style={{
                                                        height: typeLocationSelected == 1 ? "14rem" : "5rem",

                                                    }}>
                                                    {
                                                        UOMDropdown && typeLocationSelected == "1" ? <Dropdowns required={true} activateErrorHint={hasUOMError} preSelectValue={preselectUOMDrop} onOptionSelect={getUOMSelected} dropdownFilters={UOMdropdownFilters} data={UOMDropdown}></Dropdowns> : null
                                                    }
                                                    {typeLocationSelected == "1" && <Input isNumeric={true} label="Enter Available Area" value={avaiableArea}
                                                        error={hasAvailableAreaError} onChange={(e) => {
                                                            setAvailableArea(e.target.value);
                                                            setHasAvailableAreaError(false)
                                                        }}

                                                    />}

                                                    {typeLocationSelected == "1" && <span className="Available-for-Aircraft-cont"
                                                        style={{
                                                            background: availableForAircraft == true ? "#DBFFEE" : "var(--white)",
                                                            outline: availableForAircraft == true ? "1px solid #1EC496" : "var(--white)",
                                                        }}
                                                    >
                                                        <FormControlLabel control={<Checkbox checked={availableForAircraft} onChange={(e) => {
                                                            setAvailableForAircraft(e.target.checked)
                                                        }} />} label={<p
                                                            style={{
                                                                fontSize: ".6rem",
                                                                color: "var(--black-mid)",
                                                                fontWeight: "500"
                                                            }}
                                                        >Available for Aircraft</p>} />
                                                    </span>}
                                                    <span className="override-address-cont"
                                                        style={{
                                                            background: overridedAddress == true ? "#DBFFEE" : "var(--white)",
                                                            outline: overridedAddress == true ? "1px solid #1EC496" : "",

                                                        }}
                                                    >
                                                        <FormControlLabel control={<Checkbox checked={overridedAddress} onChange={(e) => {
                                                            setOverridedAddress(e.target.checked)
                                                        }} />} label={<p
                                                            style={{
                                                                fontSize: ".6rem",
                                                                color: "var(--black-mid)",
                                                                fontWeight: "500"
                                                            }}
                                                        >Override Shipping Address</p>} />
                                                    </span>
                                                    <span className="override-address-cont"
                                                        style={{
                                                            background: bondedWarehouse == true ? "#DBFFEE" : "var(--white)",
                                                            outline: bondedWarehouse == true ? "1px solid #1EC496" : "",

                                                        }}
                                                    >
                                                        <FormControlLabel control={<Checkbox checked={bondedWarehouse} onChange={(e) => {
                                                            setBondedWharehouse(e.target.checked)
                                                        }} />} label={<p
                                                            style={{
                                                                fontSize: ".6rem",
                                                                color: "var(--black-mid)",
                                                                fontWeight: "500"
                                                            }}
                                                        >Bonded Warehouse</p>} />
                                                    </span>
                                                </section>
                                                {
                                                    typeLocationSelected == "1" && <section
                                                        style={{
                                                            opacity: !availableForAircraft ? ".5" : "1",
                                                            pointerEvents: !availableForAircraft ? "none" : "",

                                                        }}
                                                    >
                                                        <div>
                                                            <h3>Estimated Aircraft Capacity</h3>
                                                            <button
                                                                disabled={!availableForAircraft}
                                                                onClick={openPopOver}>
                                                                <i className='icon-add-new'></i>
                                                            </button>
                                                            <section>
                                                                <input type="text" placeholder='Search'
                                                                    value={searchTerm}
                                                                    onChange={handleSearch}
                                                                    disabled={!availableForAircraft}
                                                                />
                                                                <i className='icon-search'></i>
                                                            </section>
                                                        </div>
                                                        <section
                                                            style={{
                                                                maxHeight: "10rem",
                                                                height: "100%",
                                                            }}
                                                        >

                                                            {aircraftTypesList.map((aircraft, idx) => (

                                                                <AircraftTypeItem
                                                                    key={idx}
                                                                    aircraftData={aircraft}
                                                                    reloadParent={getSiteInformation}
                                                                    updateParent={updateAircraftTypeItem}
                                                                />
                                                            ))}

                                                        </section>
                                                    </section>
                                                }
                                            </div>
                                        </div>
                                        {
                                            overridedAddress && <div className='hangar-contact-info-cont'>
                                                <h4>Shipping Address</h4>
                                                <section>

                                                    <Input label='Street 1' value={street1}
                                                        error={hasStreet1Error}
                                                        onChange={(e) => {
                                                            setStreet1(e.target.value)
                                                            setHasStreet1Error(false)
                                                        }}
                                                        upperCase={true}

                                                    />
                                                    <Input label='Street 2' value={street2}
                                                        onChange={(e) => {
                                                            setStreet2(e.target.value)
                                                        }}
                                                        upperCase={true}

                                                    />

                                                </section>
                                                <div>
                                                    <span>
                                                        {
                                                            countryDropdown && <Dropdowns preSelectValue={preSelectCountry} updateDropdown={updateDropdown} resetDropdownsReload={resetDropdownsReload} onOptionSelect={getCountrySelected} data={countryDropdown} required={true} activateErrorHint={hasCountryError} ></Dropdowns>
                                                        }
                                                    </span>
                                                    <span>
                                                        {
                                                            stateDropdown && <Dropdowns preSelectValue={preSelectState} updateDropdown={updateDropdown} resetDropdownsReload={resetDropdownsReload} onOptionSelect={getStateSelected} data={stateDropdown} required={true} activateErrorHint={hasStateError}></Dropdowns>
                                                        }
                                                    </span>
                                                    <span>
                                                        {
                                                            cityDropdown && <Dropdowns preSelectValue={preSelectCity} updateDropdown={updateDropdown} resetDropdownsReload={resetDropdownsReload} onOptionSelect={getCitySelected} data={cityDropdown} required={true} activateErrorHint={hasCityError}></Dropdowns>
                                                        }
                                                    </span>
                                                    <Input label='Postal code' value={postalCode} onChange={(e) => {
                                                        setPostalCode(e.target.value);
                                                        setHasPostalCodeError(false)
                                                    }}
                                                        error={hasPostalCodeError}
                                                        upperCase={true}

                                                    />
                                                    <PhoneInput
                                                        // key={countrySelected}
                                                        // defaultCountry={countrySelected.code}
                                                        placeholder="Phone"
                                                        value={phone}
                                                        onChange={(value) => setPhone(value)}

                                                    />
                                                    <Input label='Email' value={email}
                                                        error={hasEmailError} onChange={(e) => {
                                                            setEmail(e.target.value);
                                                            setHasEmailError(false)
                                                        }}
                                                        upperCase={true}

                                                    />
                                                </div>
                                            </div>
                                        }
                                    </section>)
                            }
                        </div>
                        : viewMode == "form" ?
                            <div className="form-edit-site-exp"
                                style={{
                                    // height : "10rem"
                                }}
                            >
                                <section className='form-edit-site-exp-top'>
                                    <div className='form-edit-inp-Cont'>
                                        <Input
                                            autoFocus={newSite}
                                            error={hasNameError}
                                            label='Name'
                                            name={"Name"}
                                            value={siteNameValue}
                                            onChange={(e) => {
                                                setSiteNameValue(e.target.value);
                                                setHasNameError(false);
                                            }}
                                            upperCase={true}
                                            disabled={true}
                                        />

                                        <Input
                                            disableAutocomplete={true}
                                            autoFocus={newSite}
                                            error={hasNameError}
                                            label='Code'
                                            name={"Code"}
                                            value={siteCodeValue}
                                            onChange={(e) => {
                                                setSiteCodeValue(e.target.value);
                                                // setHasNameError(false);
                                            }}
                                            upperCase={true}
                                            disabled={true}
                                            style={{
                                                width: "40%"
                                            }}
                                        />

                                    </div>
                                    <FormControl sx={{ flexDirection: "row", alignItems: "center", flexGrow: "1", gap: "var(--gap)", justifyContent: "space-around" }}>
                                        <p style={{ fontSize: "calc(var(--p-size) + .1rem)", fontWeight: "500", minWidth: "2rem", color: "var(--black)"}}>Type</p>
                                        <RadioGroup

                                            row
                                            value={typeLocationSelected || ""}
                                            onChange={(e) => setTypeLocationSelected(e.target.value)}
                                             sx={{
                                                gap: "calc(var(--gap))",
                                                flexGrow: "1",
                                                // "@media (min-width:1273px)": {
                                                // gap: "calc(var(--gap-2) + .2rem)",
                                                // },
                                            }}
                                        >
                                            {Object.entries(typeSitesMapping).map(([key, value]) => (
                                                <FormControlLabel
                                                    disabled={true}
                                                    onChange={
                                                        () => {
                                                            setHasTypeError(false)
                                                        }
                                                    }
                                                    key={key}
                                                    value={key}
                                                    control={<Radio sx={{ padding: "0", ".css-z8nmqa-MuiSvgIcon-root": { fill: "var(--green-350)" }, ".css-1bz1rr0-MuiSvgIcon-root": { fill: "var(--grey-300)" } }} />}
                                                    label={<p className='site-labeL-radio-form' style={{
                                                        color: hasTypeError ? "var(--input-error)" : ""
                                                    }}>{value}</p>}
                                                    sx={{ background: "var(--white)", height: "var(--input-height)", marginRight: "0", marginLeft: "0", width: "auto", padding: "0.3rem .3rem .3rem .3rem", borderRadius: "var(--radius)", gap: "3px", border: hasTypeError ? "2px solid var(--input-error)" : "", }}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </FormControl>
                                </section>
                                {
                                    (typeLocationSelected == 1 || typeLocationSelected == 2) && (
                                        <section className='type-Hangar-form'>
                                            <div className="hangar-capacity-cont"
                                                style={{
                                                    height: typeLocationSelected == 1 ? "17rem" : "7rem",
                                                }}
                                            >
                                                <h2>
                                                    {
                                                        typeLocationSelected == "1" ? "Hangar Configuration" : typeLocationSelected == "2" ? "Warehouse Configuration" : ""
                                                    }

                                                </h2>
                                                <div style={{
                                                    height: "15rem",
                                                }}>
                                                    <section style={{
                                                        height: typeLocationSelected == 1 ? "14rem" : "4.5rem",
                                                    }}>
                                                        {
                                                            UOMDropdown && typeLocationSelected == "1" ? <Dropdowns disabled={true} required={true} activateErrorHint={hasUOMError} preSelectValue={preselectUOMDrop} onOptionSelect={getUOMSelected} dropdownFilters={UOMdropdownFilters} data={UOMDropdown}></Dropdowns> : null
                                                        }
                                                        {typeLocationSelected == "1" && <Input isNumeric={true} label="Enter Available Area" value={avaiableArea}
                                                            error={hasAvailableAreaError} onChange={(e) => {
                                                                setAvailableArea(e.target.value);
                                                                setHasAvailableAreaError(false)
                                                            }}
                                                            disabled={true}
                                                        />}

                                                        {typeLocationSelected == "1" && <span className="Available-for-Aircraft-cont"
                                                            style={{
                                                                background: availableForAircraft == true ? "#DBFFEE" : "var(--white)",
                                                                outline: availableForAircraft == true ? "1px solid #1EC496" : "var(--white)",
                                                            }}
                                                        >
                                                            <FormControlLabel disabled={true} control={<Checkbox checked={availableForAircraft} onChange={(e) => {
                                                                setAvailableForAircraft(e.target.checked)
                                                            }} />} label={<p
                                                                style={{
                                                                    fontSize: ".6rem",
                                                                    color: "var(--black-mid)",
                                                                    fontWeight: "500"
                                                                }}
                                                            >Available for Aircraft</p>} />
                                                        </span>}
                                                        <span className="override-address-cont"
                                                            style={{
                                                                background: overridedAddress == true ? "#DBFFEE" : "var(--white)",
                                                                outline: overridedAddress == true ? "1px solid #1EC496" : "",

                                                            }}
                                                        >
                                                            <FormControlLabel disabled={true} control={<Checkbox checked={overridedAddress} onChange={(e) => {
                                                                setOverridedAddress(e.target.checked)
                                                            }} />} label={<p
                                                                style={{
                                                                    fontSize: ".6rem",
                                                                    color: "var(--black-mid)",
                                                                    fontWeight: "500"
                                                                }}
                                                            >Override Shipping Address</p>} />
                                                        </span>
                                                        <span className="override-address-cont"
                                                            style={{
                                                                background: bondedWarehouse == true ? "#DBFFEE" : "var(--white)",
                                                                outline: bondedWarehouse == true ? "1px solid #1EC496" : "",

                                                            }}
                                                        >
                                                            <FormControlLabel disabled={true} control={<Checkbox checked={bondedWarehouse} onChange={(e) => {
                                                                setBondedWharehouse(e.target.checked)
                                                            }} />} label={<p
                                                                style={{
                                                                    fontSize: ".6rem",
                                                                    color: "var(--black-mid)",
                                                                    fontWeight: "500"
                                                                }}
                                                            >Bonded Warehouse</p>} />
                                                        </span>
                                                    </section>
                                                    {typeLocationSelected == "1" && <section
                                                        style={{
                                                            opacity: ".5",
                                                            pointerEvents: "none",

                                                        }}
                                                    >
                                                        <div >
                                                            <h3>Estimated Aircraft Capacity</h3>
                                                            <button
                                                                disabled={true}

                                                                onClick={openPopOver}>
                                                                <i className='icon-add-new'></i>
                                                            </button>
                                                            <section>
                                                                <input type="text" placeholder='Search'
                                                                    value={searchTerm}
                                                                    onChange={handleSearch}
                                                                    disabled={true}
                                                                />
                                                                <i className='icon-search'></i>
                                                            </section>
                                                        </div>
                                                        <section

                                                        >

                                                            {aircraftTypesList.map((aircraft, idx) => (

                                                                <AircraftTypeItem
                                                                    key={idx}
                                                                    aircraftData={aircraft}
                                                                    reloadParent={getSiteInformation}
                                                                    updateParent={updateAircraftTypeItem}
                                                                />
                                                            ))}

                                                        </section>
                                                    </section>}
                                                </div>
                                            </div>
                                            {
                                                overridedAddress && <div className='hangar-contact-info-cont'>
                                                    <h4>Shipping Address</h4>
                                                    <section>

                                                        <Input label='Street 1' value={street1}
                                                            error={hasStreet1Error}
                                                            onChange={(e) => {
                                                                setStreet1(e.target.value)
                                                                setHasStreet1Error(false)
                                                            }}
                                                            upperCase={true}
                                                            disabled={true}
                                                        />
                                                        <Input label='Street 2' value={street2}
                                                            onChange={(e) => {
                                                                setStreet2(e.target.value)
                                                            }}
                                                            upperCase={true}
                                                            disabled={true}
                                                        />

                                                    </section>
                                                    <div>
                                                        <span>
                                                            {
                                                                countryDropdown && <Dropdowns disabled={true} preSelectValue={preSelectCountry} updateDropdown={updateDropdown} resetDropdownsReload={resetDropdownsReload} onOptionSelect={getCountrySelected} data={countryDropdown} required={true} activateErrorHint={hasCountryError} ></Dropdowns>
                                                            }
                                                        </span>
                                                        <span>
                                                            {
                                                                stateDropdown && <Dropdowns disabled={true} preSelectValue={preSelectState} updateDropdown={updateDropdown} resetDropdownsReload={resetDropdownsReload} onOptionSelect={getStateSelected} data={stateDropdown} required={true} activateErrorHint={hasStateError}></Dropdowns>
                                                            }
                                                        </span>
                                                        <span>
                                                            {
                                                                cityDropdown && <Dropdowns disabled={true} preSelectValue={preSelectCity} updateDropdown={updateDropdown} resetDropdownsReload={resetDropdownsReload} onOptionSelect={getCitySelected} data={cityDropdown} required={true} activateErrorHint={hasCityError}></Dropdowns>
                                                            }
                                                        </span>
                                                        <Input label='Postal code' value={postalCode} onChange={(e) => {
                                                            setPostalCode(e.target.value);
                                                            setHasPostalCodeError(false)
                                                        }}
                                                            error={hasPostalCodeError}
                                                            upperCase={true}
                                                            disabled={true}
                                                        />
                                                        <PhoneInput
                                                            // key={countrySelected}
                                                            // defaultCountry={countrySelected.code}
                                                            placeholder="Phone"
                                                            value={phone}
                                                            onChange={(value) => setPhone(value)}
                                                            disabled={true}
                                                            className={viewMode == "form" ? "phone-input-disabled" : ""}
                                                        />
                                                        <Input label='Email' value={email}
                                                            error={hasEmailError} onChange={(e) => {
                                                                setEmail(e.target.value);
                                                                setHasEmailError(false)
                                                            }}
                                                            upperCase={true}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        </section>)
                                }
                            </div>
                            : viewMode == "racks" ?
                                <div className="racks-exp-cont">
                                    {allRacks.map((rack, idx) => {
                                        return <RackExpandable
                                            rackBasicInfo={rack}
                                            isNewRack={mostRecentRack === rack.id ? true : false}
                                            isDraft={racksInDraft.some((e) => e.id === rack.id)}
                                            key={rack.id}
                                            idx={idx}
                                            totalLength={racks.length}
                                            informationOfDraft={racksInDraft.find((e) => e.id === rack.id)}
                                            site_id={siteBasicInfo.id}
                                            locationId={location_id}
                                            reload={reloadRack}
                                            parentListLength={listLenght}
                                            fullTotalLenght={allRacks.length}
                                        />
                                    })}
                                </div> : ""

                    }
                </section>
            </section>
        </>
    );
};